import useDataFetcher, { UseDataFetcherReturn } from 'Hooks/Http/useDataFetcher';
import VideoFolder from 'Models/Videos/VideoFolder';
import getFoldersRequest from 'Utils/Http/Requests/Folder/GetFoldersRequest';

const useFetchFolders = (doNotFetch?: boolean): UseDataFetcherReturn<VideoFolder[]> =>
	useDataFetcher(getFoldersRequest, doNotFetch);

export default useFetchFolders;
